
import React, { useState } from 'react';
import '../styles/navbar.css';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";

function Navbar(){
  const [clicked,setClicked] =useState(false)
   const closeMobileMenu = () => {
     setClicked(false);
   };
  return (
    <Container fluid className="back-nav">
      <nav>
        <div className="container">
          <ul
            
            className={clicked ? "nav-lists active" : "nav-lists"}
          >
            <li className="active">
              <Link to="/home" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className="active">
              <Link to="/about" onClick={closeMobileMenu}>
                About
              </Link>
            </li>
            <li className="active">
              <Link to="/project" onClick={closeMobileMenu}>
                Project
              </Link>
            </li>
            <li className="active">
              <Link to="/contact" onClick={closeMobileMenu}>
                Contact
              </Link>
            </li>
          </ul>
          <div className="mobile">
            <i
              id="bar"
              className={clicked ? "fa fa-times" : "fa fa-bars"}
              onClick={() => setClicked(!clicked)}
            ></i>
          </div>
        </div>
      </nav>
    </Container>
  );
}
export default Navbar;